import { Box, Button, Modal, useMediaQuery, useTheme } from "@mui/material";
import type { FC } from "react";
import { MainMagicShortcutType } from "../main-page/Shortcuts";
import background from "../../images/background.jpg";

type MagicShortcutModalProps = {
  open: boolean;
  shortcut: MainMagicShortcutType;
  onStartClick: () => void;
  onModalClose: () => void;
};

export const MagicShortcutModal: FC<MagicShortcutModalProps> = ({
  open,
  shortcut,
  onStartClick,
  onModalClose,
}) => {
  // responsive UI
  const theme = useTheme();
  const notPhone = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Modal open={open} disableAutoFocus onClose={onModalClose}>
      <Box
        id="magic-shortcut-modal"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "16px",
          padding: "16px",
          width: notPhone ? "40%" : "100%",
          height: notPhone ? "calc(100vh * 0.6)" : "auto",
          background: "white",
          borderRadius: "5px",
          backgroundImage: `url(${background})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <img
          src={shortcut?.teach || ""}
          alt="快捷功能教程图"
          style={{
            maxWidth: "100%",
            maxHeight: "80%",
            borderRadius: "5px",
            border: `1px solid ${theme.palette.secondary.dark}`,
            boxShadow: `0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)`,
          }}
        />
        <Button
          variant="contained"
          onClick={onStartClick}
          color="secondary"
          sx={{ minWidth: "150px", fontWeight: 800 }}
        >
          开始试试吧
        </Button>
      </Box>
    </Modal>
  );
};
